import { createContext, useRef } from 'react';

interface HighlightEntityContextType {
  timeoutRef: React.MutableRefObject<{
    timeout: ReturnType<typeof setTimeout>;
    entityId: string;
  } | null>;
}

export const HighlightEntityContext = createContext<HighlightEntityContextType>({
  timeoutRef: { current: null },
});

export const HighlightEntityProvider = ({ children }: { children: React.ReactNode }) => {
  const timeoutRef = useRef<{ timeout: ReturnType<typeof setTimeout>; entityId: string } | null>(null);
  return (
    <HighlightEntityContext.Provider
      value={{
        timeoutRef,
      }}
    >
      {children}
    </HighlightEntityContext.Provider>
  );
};
